function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj);
}
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols);
} return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); });
} return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
}
else {
    obj[key] = value;
} return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null)
    return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object")
        return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return (hint === "string" ? String : Number)(input); }
import { useMutation, useQueryClient } from 'react-query';
import { MILLISECONDS_IN_MINUTE } from 'utils/milliseconds';
import { useAxiosQuery } from 'api/useAxiosQuery';
import { getAccountKey } from './queryKeys';
import { getAccountChangeEmailDeleteRequest, getAccountChangeEmailInvitation, getAccountGetRequest, getAccountPasswordPutRequest, getAccountPersonalInformationPutRequest, getResendChangeEmailConfirmation } from './requests';
export var useAccount = function useAccount() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return useAxiosQuery(getAccountKey(), function () {
        return getAccountGetRequest();
    }, _objectSpread(_objectSpread({
        staleTime: 5 * MILLISECONDS_IN_MINUTE
    }, options), {}, {
        isRegionAgnostic: true
    }));
};
export var usePutAccountPassword = function usePutAccountPassword() {
    return useMutation(function (_ref) {
        var body = _ref.body;
        return getAccountPasswordPutRequest(body);
    });
};
export var usePutAccountPersonalInformation = function usePutAccountPersonalInformation() {
    var queryClient = useQueryClient();
    return useMutation(function (_ref2) {
        var body = _ref2.body;
        return getAccountPersonalInformationPutRequest(body);
    }, {
        onSuccess: function onSuccess() {
            queryClient.invalidateQueries(getAccountKey());
        }
    });
};
export var useDeleteChangeEmailRequest = function useDeleteChangeEmailRequest() {
    var queryClient = useQueryClient();
    return useMutation(function () {
        return getAccountChangeEmailDeleteRequest();
    }, {
        onSuccess: function onSuccess() {
            queryClient.invalidateQueries(getAccountKey());
        }
    });
};
export var usePatchResendChangeEmailConfirmation = function usePatchResendChangeEmailConfirmation() {
    return useMutation(function () {
        return getResendChangeEmailConfirmation();
    });
};
export var usePutChangeEmailInvitation = function usePutChangeEmailInvitation() {
    return useMutation(function (hash) {
        return getAccountChangeEmailInvitation(hash);
    });
};
